<template>
<div class="item item-file columns is-mobile">
  <div class="column">
    <span class="file_name">{{ item.name }}</span>
    <span 
    v-if="item.size"
    class="file_size">{{ humanFileSize(item.size) }}</span>
    <q-progress
      :percentage="item.progress*100"
      style="height: 4px"
      class="stripe animate"
    ></q-progress>
  </div>
  <button class="column is-narrow"
  style="padding: 0 1rem;"
  @click="remove(item)">
    <i class="material-icons">&#xE5CD;</i>
  </button>
</div>
</template>

<script>
import Vue from 'vue'

function base64_to_uint (b64_str) {
  var raw = window.atob(b64_str)
  var rawLength = raw.length
  var array = new Uint8Array(new ArrayBuffer(rawLength))

  for (var i = 0; i < rawLength; i++) {
    array[i] = raw.charCodeAt(i)
  }

  return array
}

function UploadSlotInitXhr () {
  var UploadSlot = function (data) {
    this.item = data.item
    this.store = data.store
    this.vm = data.vm
    this.form = new FormData()
    this.progress = 0
    this.id = 0
    this.item.id = null
    this.isFinish = false
    this.isCancel = false
    this.isHidden = false
    this.isError = false
  }

  UploadSlot.prototype.upload = function (data) {
    var uploadSlot = this
    data.token = global.token
    this.vm.$http.post(
      global.app_path + 'upload.php',
      data,
      {
        progress: function (e) {
          if (e.lengthComputable) {
            uploadSlot.progress = e.loaded / e.total
          }
          else {
            uploadSlot.progress = Math.min(0.75, uploadSlot.upload_progress + 0.01)
          }

          uploadSlot.store.commit('SetUploadProgress', uploadSlot)
        }
      }
    )
    .then(function (res) {
      var resp = res.body

      if (!resp.error) {
        uploadSlot.store.commit('AddFileCat', {
          cat: uploadSlot.item.cat,
          file_id: resp.file_id
        })
      }
      else {
        uploadSlot.isError = true
      }
      uploadSlot.isFinish = true
    },
    function (res) {
      uploadSlot.isError = true
      uploadSlot.isFinish = true
    })
  }

  UploadSlot.prototype.conf = function (data) {
    var uploadSlot = this

    this.item = data.item
    this.store = data.store
    this.vm = data.vm

    this.item.remove = function () {
      uploadSlot.transfer.abort()
      uploadSlot.isCancel = true
      uploadSlot.isFinish = true
    }

    if (typeof this.reader.has !== 'undefined' &&
    this.reader.has('file')) {
      this.reader.delete('file')
    }
  }

  UploadSlot.prototype.start = function () {
    var uploadSlot = this
    if (typeof this.item.file === 'string') {
      // photo from camera plugin
      let typed_arr = base64_to_uint(this.item.file)
      this.item.size = typed_arr.length
      let blob = new Blob([typed_arr], {
        type: 'image/jpeg'
      })

      this.form.append('file', blob)
      this.upload(this.form)
      this.progress = 1
    }
    else {
      this.form.append('file', this.item.file)
      this.upload(this.form)
      this.progress = 1
    }
  }

  return UploadSlot
}

export default {
  name: 'fileuploader',
  data () {
    return {
      currentFileId: 0,
      networkError: false,
      Slot: UploadSlotInitXhr(),
      slots: []
    }
  },

  props: {
    item: {
      required: true
    }
  },

  methods: {
    remove: function (item) {
      // this.uploadSlot = null
      this.$store.commit('RemoveUpload', item)
    },

    humanFileSize: function (bytes) {
      var thresh = 1024

      if (Math.abs(bytes) < thresh) {
        return bytes + ' o'
      }
      var units = ['ko', 'Mo', 'Go', 'To', 'Po', 'Eo', 'Zo', 'Yo']
      var u = -1
      do {
        bytes /= thresh
        ++u
      } while (Math.abs(bytes) >= thresh && u < units.length - 1)
      return bytes.toFixed(1) + ' ' + units[u]
    }
  },

  mounted: function () {
    this.uploadSlot = new this.Slot({
      item: this.item,
      store: this.$store,
      vm: this
    })

    console.log('upload start')
    this.uploadSlot.start()
  }
}
</script>

<style>
.item-file {
  margin-top: 0;
  margin-bottom: 0;
}
.file_size {
  font-size: 12px;
  float: right;
  color: #666 !important;
}

</style>
